const customCSSPropertiesMap: Record<string, string> = {
  activeDrawerWidth: '--awsui-active-drawer-width-en6003',
  breadcrumbsGap: '--awsui-breadcrumbs-gap-en6003',
  contentGapLeft: '--awsui-content-gap-left-en6003',
  contentGapRight: '--awsui-content-gap-right-en6003',
  contentHeight: '--awsui-content-height-en6003',
  defaultMaxContentWidth: '--awsui-default-max-content-width-en6003',
  defaultMinContentWidth: '--awsui-default-min-content-width-en6003',
  footerHeight: '--awsui-footer-height-en6003',
  headerGap: '--awsui-header-gap-en6003',
  headerHeight: '--awsui-header-height-en6003',
  layoutWidth: '--awsui-layout-width-en6003',
  mainGap: '--awsui-main-gap-en6003',
  mainOffsetLeft: '--awsui-main-offset-left-en6003',
  mainTemplateRows: '--awsui-main-template-rows-en6003',
  maxContentWidth: '--awsui-max-content-width-en6003',
  minContentWidth: '--awsui-min-content-width-en6003',
  mobileBarHeight: '--awsui-mobile-bar-height-en6003',
  notificationsGap: '--awsui-notifications-gap-en6003',
  notificationsHeight: '--awsui-notifications-height-en6003',
  offsetTop: '--awsui-offset-top-en6003',
  offsetTopWithNotifications: '--awsui-offset-top-with-notifications-en6003',
  overlapHeight: '--awsui-overlap-height-en6003',
  navigationWidth: '--awsui-navigation-width-en6003',
  splitPanelReportedHeaderSize: '--awsui-split-panel-reported-header-size-en6003',
  splitPanelReportedSize: '--awsui-split-panel-reported-size-en6003',
  splitPanelHeight: '--awsui-split-panel-height-en6003',
  splitPanelMinWidth: '--awsui-split-panel-min-width-en6003',
  splitPanelMaxWidth: '--awsui-split-panel-max-width-en6003',
  toolsMaxWidth: '--awsui-tools-max-width-en6003',
  toolsWidth: '--awsui-tools-width-en6003',
  toolsAnimationStartingOpacity: '--awsui-tools-animation-starting-opacity-en6003',
  contentScrollMargin: '--awsui-content-scroll-margin-en6003',
  flashbarStackDepth: '--awsui-flashbar-stack-depth-en6003',
  flashbarStackIndex: '--awsui-flashbar-stack-index-en6003',
  flashbarStickyBottomMargin: '--awsui-flashbar-sticky-bottom-margin-en6003',
  stackedNotificationsBottomMargin: '--awsui-stacked-notifications-bottom-margin-en6003',
  stackedNotificationsDefaultBottomMargin: '--awsui-stacked-notifications-default-bottom-margin-en6003',
};
export default customCSSPropertiesMap;
